import { DataLayerAnalytics, User, UserAttributes } from './analytics.interface';

export const enum DATA_ANALYTICS {
    PAGELOAD = 'page load',
    SYSTEMENVIRONMENT = 'responsive',
    ACCOUNTTYPE = 'accountType',
    ACCOUNT = 'account',
    DESKTOP = 'desktop',
    MOBILE = 'mobile'
  }


  
  export const userAttributes: UserAttributes = {
    is_logged_in: 'unauthenticated'
  };
  
  export const NonLoggedInUser: User = {
    attributes: userAttributes
  };
  
  export const enum USER_LOGGED_IN_STATUS {
    UNAUTHENTICATED = 'unauthenticated',
    AUTHENTICATED = 'authenticated',
    HOT = 'hot',
  }
  
  export const DataLayerPageLoad: DataLayerAnalytics = {
    event_detail: DATA_ANALYTICS.PAGELOAD,
    event: DATA_ANALYTICS.PAGELOAD,
    user: {
      attributes: {
        is_logged_in: '',
        login_method: '',
        login_state: '',  
      },
      profile: {
        skymiles_number: '',
        skymiles_tier: '',
        email: '',
        encrypted_email: '',
        email_domain: '',
        available_miles: '',
        amex_card_type: '',
        company_name: ''
      }
    },
    page: {
      info: {
        legacy_page_name: 'Sky Club: Delta Sky Club Membership',
        page_name: 'dal:sky-club:purchase-membership',
        page_url: '/sky-club/purchase-membership',
        page_type: 'sky-club',
        previous_page_name: '',
        previous_page_url: '',
        section: 'sky-club',
        sub_section: 'purchase-membership',
        country: 'us',
        language: 'en',
        sys_env: 'desktop',
        page_load_time: 5
      }
    }
  }
  